"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicLicense = publicLicense;
// Explicit allowlist: key material can never become repository/snapshot data.
function publicLicense(item) {
    return {
        id: item.id, manufacturer: item.manufacturer, product: item.product,
        version: item.version, licenseType: item.licenseType,
        registrationAccount: item.registrationAccount, vendorPanelUrl: item.vendorPanelUrl,
        googleDriveUrl: item.googleDriveUrl,
        seatsPurchased: item.seatsPurchased, seatsUsed: item.seatsUsed, seatsFree: item.seatsFree,
        assignment: item.assignment, purchaseDate: item.purchaseDate, expirationDate: item.expirationDate,
        cost: item.cost, billingCycle: item.billingCycle, status: item.status, comment: item.comment,
        hasLicenseKey: item.hasLicenseKey, createdAt: item.createdAt, updatedAt: item.updatedAt,
    };
}
